import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  Stack,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StarIcon from "@mui/icons-material/Star";
import PricingComparison from "./PricingComparison";

const Pricing = () => {
  const navigate = useNavigate();
  const userId = useSelector((state) => state.main.userId);
  const planTier = useSelector((state) => state.setProfile?.profile?.planTier);
  const isLoggedInBasic = !!userId && (!planTier || planTier === "basic");

  const goToUpgrade = (plan) => {
    if (!userId) {
      navigate("/signup");
      return;
    }
    navigate(`/profile?step=subscription&plan=${plan}`);
  };

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, md: 8 } }}>
      <PricingComparison
        isLoggedInBasic={isLoggedInBasic}
        onSelectBasic={
          isLoggedInBasic
            ? undefined
            : () => navigate(userId ? "/profile?step=subscription" : "/signup")
        }
        onSelectMonthly={() => goToUpgrade("monthly")}
        onSelectYearly={() => goToUpgrade("yearly")}
      />
    </Container>
  );
};

export default Pricing;
